import { render, staticRenderFns } from "./Recordings.vue?vue&type=template&id=1977ad78&scoped=true"
import script from "./Recordings.vue?vue&type=script&lang=js"
export * from "./Recordings.vue?vue&type=script&lang=js"
import style0 from "./Recordings.vue?vue&type=style&index=0&id=1977ad78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1977ad78",
  null
  
)

export default component.exports